import * as React from 'react';
var CascaderContext = /*#__PURE__*/React.createContext(null);
export default CascaderContext;